<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      row
      wrap
      justify-center
      align-center>
      <v-flex
        v-for='chart in charts'
        :key='chart.name'
        md12
        sm12
        lg4
        >
        <material-chart-card
          :data='chart.data'
          :options='chart.options'
          :color='chart.color'
          :type='chart.type'>
          <h4 class='title font-weight-light'>{{chart.title}}</h4>
          <p class='category d-inline-flex font-weight-light'>

            <v-icon
              :color='chart.percentChange.color'
              small>
              {{ chart.percentChange.icon }}
            </v-icon>

            <span :class='`${chart.percentChange.color}--text`'> {{ chart.percentChange.percent }}% </span>&nbsp;
            {{ chart.percentChange.message }}
          </p>

          <template #actions>
            <v-icon class='mr-2' small>
              mdi-clock-outline
            </v-icon>
            <span class='caption grey--text font-weight-light'>
              updated {{ chart.lastUpdated }} minutes ago
            </span>
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex v-for='card in statsCards' :key='card.name' xs12 lg6>
            <material-stats-card
              :value='card.value'
              :color='card.color'
              :icon='card.icon'
              :title='card.title'
              :small-value='card.smallVal'
              sub-icon='mdi-calendar'
              sub-icon-color='primary'
              sub-text='All Time'
              sub-text-color='text-primary'
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12 lg12 v-for='table in tables' :key='table.name'>
        <material-card
        :color='table.color'
        :title='table.title'
        :text='table.text'>
          <v-data-table
            :headers='table.headers'
            :items='table.items'
            hide-actions>
            <template #headerCell=' { header }'>
              <span
                :class='`font-weight-light text-${table.color} text--darken-3`'
                v-text='header.text'/>
            </template>
            <template #items=" { index, item }">
              <td
                class='text-xs-left'
                v-for='(value, propertyName) in item.tableData'
                :key='propertyName'>
                {{ value }}
              </td>
              <td class='text-xs-right'>
                <v-menu
                  offset-y
                  content-class="dropdown-menu"
                  transition="slide-y-transition">
                  <v-btn
                    slot="activator"
                    color="secondary">
                    <v-icon>mdi-chevron-down</v-icon>
                    Actions
                  </v-btn>
                  <v-card>
                    <v-list dense>
                      <router-link
                        :to='{
                          name: table.actions.link.name,
                          params: { id: item.id }
                        }'>
                        <v-list-tile>
                          <v-list-tile-title v-text="'Edit'"/>
                        </v-list-tile>
                      </router-link>
                      <!-- <EmailContactDialog>
                        <template #activator=" { on } ">
                          <v-list-tile v-on='on'>
                            <v-list-tile-title
                              v-text="'Contact'"/>
                          </v-list-tile>
                        </template>
                      </EmailContactDialog> -->
                    </v-list>
                  </v-card>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import nDaysAgo from '../utils/nDaysAgo'
import { mapGetters, mapActions } from 'vuex'
import EmailContactDialog from '../components/busie/EmailContactDialog'

export default {
  components: {
    EmailContactDialog
  },
  data () {
    return {
    }
  },
  computed: {
    charts() {
      return [
        {
          name: 'daily-quotes',
          data: this.dailyQuoteData,
          options: this.dailyQuoteOptions,
          color: 'info',
          type: 'Line',
          title: 'Daily Quotes',
          percentChange: this.quotePercentChange,
          lastUpdated: this.quoteLastUpdated
        },
      ]
    },
    statsCards () {
      return [
        {
          name: 'quotes',
          value: `${this.getLength}`,
          color: 'green',
          icon: 'mdi-trending-up',
          title: 'Quotes'
        },
        {
          name: 'quote-conversion',
          value: this.conversion,
          color: 'orange',
          icon: 'mdi-check',
          title: 'Quote Conversion',
          smallVal: '%'
        },
      ]
    },
    tables() {
      return [
        {
          name: 'recent',
          color: 'warning',
          title: 'Recent Quotes',
          text: 'Most recently quoted trips',
          items: this.lastFiveQuotes,
          headers: [
            { sortable: false, text: 'Trip ID', value: 'tripID' },
            { sortable: false, text: 'Name', value: 'name' },
            { sortable: false, text: 'Email', value: 'email' },
            { sortable: false, text: 'Details', value: 'details' },
            { sortable: false, text: 'Price', value: 'price' },
            { sortable: false, text: 'Actions', value: 'actions', align: 'right' }
          ],
          actions: {
            link: {
              name: 'Edit Trip',
            }
          }
        }
      ]
    },
    lastFiveQuotes() {
      return this.last(5).map( quote => Object.assign(quote, { tableData: {
          tripID: quote.trip.trip_id,
          name: quote.trip.trip_planner.name,
          email: quote.trip.trip_planner.email,
          details: `${quote.trip.passengers} passengers | ${quote.live_miles} mi.`,
          price: quote.cost
      }}));
    },
    quoteLastUpdated () {
      return Math.floor( ( new Date() - this.lastUpdated ) / 216000 )
    },
    quotePercentChange () {
      const today = this.todaysQuotes
      const yesterday = this.yesterdaysQuotes
      const percent = Math.round((today.length - yesterday.length)/yesterday.length) * 100
      return {
        percent: percent ?
          percent === Infinity || percent === -Infinity ?
            (today.length - yesterday.length) * 100 : percent
          : 0,
        color: this.percentChangeColor(percent),
        icon: this.percentChangeIcon(percent),
        message: this.percentChangeMessage(percent)
      }
    },
    percentChangeColor () {
      return percent => {
        if(percent === Infinity || percent > 0) {
          return 'green'
        } else if (percent === -Infinity || percent < 0) {
          return 'red'
        } else {
          return 'black'
        }
      }
    },
    percentChangeIcon () {
      return percent => {
        if (percent === Infinity || percent > 0) {
          return 'mdi-arrow-up'
        } else if (percent === -Infinity || percent < 0) {
          return 'mdi-arrow-down'
        } else {
          return 'mdi-minus'
        }
      }
    },
    percentChangeMessage () {
      return percent => {
        if (percent === Infinity || percent > 0) {
          return 'increase in todays quotes'
        } else if (percent === -Infinity || percent < 0) {
          return 'decrease in todays quotes'
        } else {
          return 'change in todays quotes'
        }
      }
    },
    conversion () {
      return `${Math.trunc(100 * this.getNBooked / this.getLength)}`
    },
    dailyQuoteData () {
      let series = [],
        labels = [],
        temp = []
      for (var i = 6; i >= 0; i--) {
        let now = new Date()
        let date = new Date(now.setDate(now.getDate() - i))
        temp.push(this.lastWeeksQuotes.filter(
          quote => new Date(quote.created).getDate() === date.getDate()).length)
        labels.push(this.getDayLabel(date.getDay()))
      }
      series.push(temp)
      return { series, labels }
    },
    dailyQuoteOptions () {
      return {
        lineSmooth: this.$chartist.Interpolation.cardinal({ tension: 0 }),
        low: 0,
        high: this.chartHigh,
        onlyInteger: true,
        chartPadding: { top: 0, right: 0, bottom: 0, left: 0 }
      }
    },
    lastWeeksQuotes () {
      const now = new Date()
      const range = {
        type: 'created',
        upper: now.toISOString(),
        lower: nDaysAgo(7).toISOString()
      }
      return this.byRange(range)
    },
    todaysQuotes () {
      const now = new Date()
      const range = {
        type: 'created',
        upper: now.toISOString(),
        lower: nDaysAgo(0).toISOString()
      }
      return this.byRange(range)
    },
    yesterdaysQuotes () {
      const range = {
        type: 'created',
        upper: nDaysAgo(0).toISOString(),
        lower: nDaysAgo(1).toISOString()
      }
      return this.byRange(range)
    },
    dateLabels: () => {
      return { 0: 'Sun', 1: 'Mon', 2: 'Tues', 3: 'Weds', 4: 'Thurs', 5: 'Fri', 6: 'Sat' }
    },
    chartHigh () {
      return this.dailyQuoteData.series[0].reduce((a, b) => Math.max(a, b)) + 5
    },
    ...mapGetters('quotes', [
      'last',
      'byId',
      'byRange',
      'filter',
      'getLength',
      'getNBooked',
      'lastUpdated'
    ])
  },
  methods: {
    getDayLabel (day) {
      return this.dateLabels[day]
    },
    complete (index) {
      this.list[index] = !this.list[index]
    },
    send () {
      console.log('send');
    },
    ...mapActions('app', [ 'raiseError' ])
  }
}
</script>
